import { handleActions } from 'redux-actions';

import actions from '../action';
import { sortSectionStatus } from '@modules/questionnaires/useQuestionSteps';
import { SECTIONS_LENGTH } from '@model/questionmaires';
const {
  actionTypes: { questionnaires },
} = actions;

const defaultState = {
  status: sortSectionStatus(
    Array.from(
      new Array(SECTIONS_LENGTH.reduce((result, item) => result + item, 0)),
    ).map((_, i) => 0),
  ),
  isActionLoading: false,
  isFetchLoading: false,
  isRiskLoading: false,
  QSstepData: { step: 0 },
  QSaccessData: {},
  allComplexityData: {},
  pdfCustomizationSettings: {},
  currentComplexityMode: 'auto',
};

export default handleActions(
  {
    [questionnaires.CHANGE_QUESTIONS]: (state, action) => ({
      ...state,
      ...action.payload,
    }),
    [questionnaires.CLEAR_QUESTIONS]: (state, action) => ({
      ...defaultState,
    }),
    [questionnaires.QUESTIONNAIRE_ACCESS_HANDLER]: (state, action) => ({
      ...state,
      QSaccessData: action.payload,
    }),
    [questionnaires.CHANGE_COMPLEXITY_MODE]: (state, action) => ({
      ...state,
      currentComplexityMode: action.payload,
    }),
    [questionnaires.CHANGE_SIDEBAR_SECTION_LEVEL]: (state, action) => ({
      ...state,
    }),
    [questionnaires.CANCEL_QUESTION_EDIT]: (state, action) => ({
      ...state,
    }),
  },
  defaultState,
);
